import { render, staticRenderFns } from "./Ace.vue?vue&type=template&id=3c4cba2c&"
import script from "./Ace.vue?vue&type=script&lang=js&"
export * from "./Ace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports